/* eslint-disable jira/filename-case */
export default class ExtensibleError extends Error {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	constructor(message: string, options?: any) {
		super(message, options);
		this.name = this.constructor.name;
	}
}
